import { getPeriodTypeFromId } from "../../period/PeriodType.js";
import WrapperFormulaNode from "./WrapperFormulaNode.js";

/**
 * Wraps another node to represent its value in the context of a
 * period shifting.
 *
 * @param {number} shift - Number of period to shift
 * @param {PeriodType} shiftPeriodType - Which kind of period to shift
 */
export default class PeriodShiftFormulaNode extends WrapperFormulaNode {
	constructor({ shift, shiftPeriodType }) {
		super(...arguments);
		this._shift = shift;
		this._shiftPeriodType = shiftPeriodType;
	}

	getShift() {
		return this._shift;
	}

	getShiftPeriodType() {
		return this._shiftPeriodType;
	}

	accept(visitor, additionalInformation) {
		return visitor.visitPeriodShiftFormulaNode(this, additionalInformation);
	}

	_serializedProperties() {
		const properties = super._serializedProperties();

		properties.shift = this._shift;
		properties.shiftPeriodType = this._shiftPeriodType?.getId();

		return properties;
	}

	static transformMaterializationData(data) {
		super.transformMaterializationData(...arguments);
		data.shiftPeriodType = getPeriodTypeFromId(data.shiftPeriodType);
	}

	static getType() {
		return "PeriodShiftNode";
	}
}
